import { instance } from '@/libs/api/instance'

const getFeatures = (features = []) => {
  return instance.post('/v1/features', features)
}

export default {
  getFeatures,
}
